import { GlButton, GlDisclosureDropdown, GlLink, GlLoadingIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import TooltipOnTruncate from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/tooltip_on_truncate/tooltip_on_truncate.vue?vue3';
import { s__, __, sprintf } from '~/locale';
import { reportToSentry } from '~/ci/utils';
import CiIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ci_icon/ci_icon.vue?vue3';
import { getQueryHeaders } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipeline_details/graph/utils.js?vue3';
import { graphqlEtagPipelinePath } from '~/ci/pipeline_details/utils';
import { getIdFromGraphQLId, setupQueryPollingByVisibility } from '~/graphql_shared/utils';
import { PIPELINE_POLL_INTERVAL_DEFAULT } from '~/ci/constants';
import JobDropdownItem from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/common/private/job_dropdown_item.vue?vue3';
import { sortJobsByStatus } from './utils/data_utils';
import getDownstreamPipelineJobsQuery from './graphql/queries/get_downstream_pipeline_jobs.query.graphql';
/**
 * Renders a downstream pipeline dropdown for the pipeline mini graph.
 */ export default {
    name: 'DownstreamPipelineDropdown',
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        CiIcon,
        GlButton,
        GlDisclosureDropdown,
        GlLink,
        GlLoadingIcon,
        JobDropdownItem,
        TooltipOnTruncate
    },
    props: {
        pipeline: {
            type: Object,
            required: true
        }
    },
    emits: [
        'job-action-executed'
    ],
    data () {
        return {
            isDropdownOpen: false,
            pipelineJobs: []
        };
    },
    apollo: {
        pipelineJobs: {
            context () {
                return {
                    ...getQueryHeaders(this.graphqlEtag),
                    featureCategory: 'continuous_integration'
                };
            },
            query: getDownstreamPipelineJobsQuery,
            variables () {
                return {
                    iid: this.pipeline.iid,
                    fullPath: this.projectPath,
                    retried: false
                };
            },
            skip () {
                return !this.isDropdownOpen || !this.projectPath;
            },
            pollInterval: PIPELINE_POLL_INTERVAL_DEFAULT,
            update ({ project }) {
                const jobs = project?.pipeline?.jobs?.nodes || [];
                return sortJobsByStatus(jobs);
            },
            error (error) {
                createAlert({
                    message: s__('Pipelines|There was a problem fetching the downstream pipeline jobs.')
                });
                reportToSentry(this.$options.name, error);
            }
        }
    },
    computed: {
        dropdownAriaLabel () {
            return sprintf(__('View Pipeline: %{title}'), {
                title: this.pipelineName
            });
        },
        dropdownHeaderText () {
            return `${__('Pipeline')}: ${this.pipelineName}`;
        },
        dropdownTooltipTitle () {
            const status = this.pipeline?.detailedStatus?.label || __('unknown');
            return `${this.pipelineName} - ${status}`;
        },
        graphqlEtag () {
            // eslint-disable-next-line @gitlab/no-hardcoded-urls -- /api/graphql is an ETag resource identifier, not a navigational URL
            return graphqlEtagPipelinePath('/api/graphql', this.pipelineId);
        },
        isLoading () {
            return this.$apollo.queries.pipelineJobs.loading;
        },
        pipelineId () {
            return getIdFromGraphQLId(this.pipeline.id).toString();
        },
        pipelineName () {
            return this.pipeline?.name || this.pipeline?.project?.name || __('Downstream pipeline');
        },
        projectPath () {
            return this.pipeline?.project?.fullPath || '';
        }
    },
    mounted () {
        this.pollingVisibilityCleanup = setupQueryPollingByVisibility(this.$apollo.queries.pipelineJobs);
    },
    beforeDestroy () {
        this.pollingVisibilityCleanup?.();
    },
    methods: {
        onHideDropdown () {
            this.isDropdownOpen = false;
            this.$apollo.queries.pipelineJobs.stopPolling();
        },
        onShowDropdown () {
            this.isDropdownOpen = true;
            this.$apollo.queries.pipelineJobs.startPolling(PIPELINE_POLL_INTERVAL_DEFAULT);
        }
    }
};
